import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { UserAuthorizationService } from '../../../security/services/user-authorization.service';
import { SharedPushNotificationService } from '../../services/shared-push-notification.service';

@Component({
    selector: 'app-push-notification-indicator',
    templateUrl: './push-notification-indicator.component.html',
    styleUrls: ['./push-notification-indicator.component.scss'],
})
export class PushNotificationIndicatorComponent implements OnInit {

    protected isLoggedIn$ = new BehaviorSubject<boolean>(false);

    constructor(
        protected authService: UserAuthorizationService,
        protected sharedPushNotificationService: SharedPushNotificationService,

    ) { }

    ngOnInit() {
        this.updateIsLoggedIn();
    }

    protected enablePushNotification(): void {
        this.sharedPushNotificationService.enablePushNotification();
    }

    private updateIsLoggedIn(): void {
        this.authService.user$.subscribe(user => {
            this.isLoggedIn$.next(user != null);
        })
    }
}
